import { oqulyqtarApi } from "../api";

const subsApi = oqulyqtarApi.injectEndpoints({
  endpoints: (build) => ({
    getSubs: build.query({
      query: (filters) => ({
        url: `/subscription/list${filters && filters}`,
        method: "GET",
      }),
    }),
    getSingleSubscription: build.query({
      query: (filters) => ({
        url: `/subscription/view${filters && filters}`,
        method: "GET",
      }),
    }),
    postSubs: build.mutation({
      query: (payload) => ({
        url: `/subscription/create`,
        method: "POST",
        body: payload,
      }),
    }),
    deleteSubs: build.mutation({
      query: (id) => ({
        url: `/subscription/delete?subscription_id=${id}`,
        method: "DELETE",
      }),
    }),
    setSubUser: build.mutation({
      query: (payload) => ({
        url: `/subscription/set-subsc-user`,
        method: "POST",
        body: payload,
      }),
    }),
    deleteSubUser: build.mutation({
      query: (payload) => ({
        url: `/subscription/unset-subsc-user`,
        method: "DELETE",
        body: payload,
      }),
    }),
    getCheckActivePackage: build.mutation({
      query: (payload) => ({
        url: `/subscription/check-active-package`,
        method: "GET",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyGetSubsQuery,
  usePostSubsMutation,
  useDeleteSubsMutation,
  useSetSubUserMutation,
  useDeleteSubUserMutation,
  useGetCheckActivePackageMutation,
  useLazyGetSingleSubscriptionQuery,
} = subsApi;
